export default __webpack_public_path__ + "static/media/icon-add-cricle-outline.29e963fd.svg";